import { SET_DROPDOWN_VALUE } from "../action";

export function setDropdownValue(domainName, domainValue) {
  return (dispatch) => {
    dispatch({
      type: SET_DROPDOWN_VALUE,
      payload: { domainName, domainValue },
    });
  };
}
